// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Nav bar */
.logo {
  width: clamp(140px, 22vw, 300px);
  height: auto;
  display: block;
}

.logo img {
  width: 100%;
  height: auto;
  display: block;
}

.nav-link {
  margin-right: 20px;
}

.navicon {
  padding: 0.5rem;
  color: white;
}

.navrightarea {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.cwd {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.logouttext {
  margin-left: 15px;
  display: inline;
  cursor: pointer;
}

.memname {
  display: inline;
  margin-left: 15px;
  cursor: default;
}

.navbar-collapse {
  flex-grow: 1;
}

.navbar-nav {
  justify-content: flex-start;
  flex-grow: 1;
}

.navbar-toggler {
  margin-left: auto;
  flex: 0 0 auto;
}

@media (max-width: 1000px) {
  .logo {
    width: 200px;
  } /* 不夠再調 120px */
  .nav-link {
    margin-right: 12px;
  }
  .navbar-collapse {
    flex: 1 1 auto;
  }
  .navbar-nav {
    flex-wrap: nowrap;
    min-width: 0; /* 允許內容壓縮 */
  }
  .navbar-nav {
    justify-content: center;
  }
  .navw {
    justify-content: space-between;
  }
}
.custom-navbar {
  transform: translateY(0);
}

.custom-navbar.hide {
  transform: translateY(-100%);
}

.custom-navbar.show {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,YAAA;AACA;EACE,gCAAA;EACA,YAAA;EACA,cAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAGF;;AADA;EACI,kBAAA;AAIJ;;AAFA;EACI,eAAA;EACA,YAAA;AAKJ;;AAHA;EACI,aAAA;EACA,iBAAA;EACA,8BAAA;AAMJ;;AAJA;EAEI,WAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAMJ;;AAHA;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AAMJ;;AAJA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AAOJ;;AAJA;EACI,YAAA;AAOJ;;AAJE;EACA,2BAAA;EACA,YAAA;AAOF;;AAJE;EACE,iBAAA;EACA,cAAA;AAOJ;;AAJE;EACE;IAAQ,YAAA;EAQV,EARgC,eAAA;EAC9B;IAAY,kBAAA;EAUd;EATE;IAAmB,cAAA;EAYrB;EAXE;IACE,iBAAA;IACA,YAAA,EAAA,WAAA;EAaJ;EAXE;IACI,uBAAA;EAaN;EAXE;IACI,8BAAA;EAaN;AACF;AAVE;EACA,wBAAA;AAYF;;AAVA;EACE,4BAAA;AAaF;;AAXA;EACE,wBAAA;AAcF","sourcesContent":["/* Nav bar */\n.logo {\n  width: clamp(140px, 22vw, 300px);\n  height: auto;\n  display: block;\n}\n.logo img { \n  width: 100%; \n  height: auto; \n  display: block; \n}\n.nav-link {\n    margin-right: 20px;\n}\n.navicon {\n    padding: 0.5rem;\n    color: #ffff;\n}\n.navrightarea {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n}\n.cwd {\n    // max-width:1200px; \n    width:100%; \n    margin:0 auto;\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.logouttext {\n    margin-left: 15px;\n    display: inline;\n    cursor: pointer;\n}\n.memname {\n    display: inline;\n    margin-left: 15px;\n    cursor:default;\n\n}\n.navbar-collapse {\n    flex-grow: 1; // 中間主選單填滿中間空間\n  }\n  \n  .navbar-nav { \n  justify-content: flex-start;\n  flex-grow: 1;\n  }\n  \n  .navbar-toggler {\n    margin-left: auto; \n    flex: 0 0 auto; \n  }\n\n  @media(max-width: 1000px){\n    .logo { width: 200px; }       /* 不夠再調 120px */\n    .nav-link { margin-right: 12px; }\n    .navbar-collapse { flex: 1 1 auto; }\n    .navbar-nav { \n      flex-wrap: nowrap; \n      min-width: 0;               /* 允許內容壓縮 */\n    }\n    .navbar-nav {\n        justify-content:center;\n      }\n    .navw {\n        justify-content: space-between;\n    }\n  }\n\n  .custom-navbar {\n  transform: translateY(0);\n}\n.custom-navbar.hide {\n  transform: translateY(-100%);\n}\n.custom-navbar.show {\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
